module.exports = __webpack_public_path__ + "static/img/7.916b463.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/sp/7.png
// module id = k6T6
// module chunks = 0